import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useController } from 'react-hook-form';
import { FormErrorMessage } from '../form/error-message';
import { Select } from './uncontrolled';
export function FormSelect({ name, ...props }) {
    const { field, fieldState } = useController({ name });
    return (_jsxs("div", { className: "flex flex-col w-full gap-stack-tight", children: [_jsx(Select, { ...props, value: field.value, onChange: value => {
                    field.onChange(value);
                    props.onChange?.(value);
                }, error: !!fieldState.error?.message }), _jsx(FormErrorMessage, { error: fieldState.error?.message })] }));
}
